module.exports = __webpack_public_path__ + "img/month_package.e9ad6e63.png";